import type { InferOutput } from "valibot";
import { nanoid } from "nanoid";

declare global { const toasts: Toast[]; }

export const toastSchema = v.object({
  id: v.optional(v.string(), () => nanoid()),
  type: v.union([v.literal("success"), v.literal("error"), v.literal("info")]),
  content: v.string(),
  links: v.array(linkSchema),
  duration: v.optional(v.number()),
});
export type Toast = InferOutput<typeof toastSchema>;
